import axios from "axios";
import { saveAs } from "file-saver";
import { extractIDs } from "../../../helpers/extractIDs";
import { api_get, api_post } from "../../../services/api";
import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions";
import { invoicesTransferTypes } from "../../reducers/invoicesTransfer/types";

const {
  CLEAR_INVOICES,
  SET_INPUTS,
  GET_INVOICES_TRANSFER,
  SELECT_INVOICE_ID,
  CANCEL_INVOICE_TRANSFER,
  SET_FORM_CANCEL_INVOICE,
} = invoicesTransferTypes;

const qid = process.env.REACT_APP_QID_INVOICES;
const mainUrl = `${process.env.REACT_APP_URL_PAY}/invoices`;

export const handleInvoicesInputs = (key = '', value = '') => {
  return {
    type: SET_INPUTS,
    payload: {
      key, value,
    },
  };
};

export const getInvoicesTransfer = (start, end, stations) => {
  const ids = extractIDs(stations);
  const paramsString = `?qid=${qid}&start=${start}&end=${end}&stations=${ids.join("&stations=")}`;
  const url = `${mainUrl}/report/table${paramsString}`;
  return async (dispatch) => {
    dispatch(startRequestComp('invoicesTransferLoading'));
    await api_get(url).then(resp => {
      resp.length === 0 && dispatch(setSnackbar('No se encontraron facturas', 'info'));
      dispatch({
        type: GET_INVOICES_TRANSFER,
        payload: resp,
      });
      dispatch(stopRequestComp('invoicesTransferLoading'));
    }).catch(error => {
      const err = error?.message ? error?.message : 'Error al obtener las facturas';
      dispatch(setSnackbar(err));
      dispatch(stopRequestComp('invoicesTransferLoading'));
    });
  };
};

export const getInvoicesTransfer_ = (startDate, endDate, station) => {
  const url = `${mainUrl}/transfers/${station}?start=${startDate}&end=${endDate}&qid=${qid}`;
  return async dispatch => {
    dispatch(startRequestComp('invoicesTransferLoading'));
    await api_get(url).then(resp => {
      dispatch({
        type: GET_INVOICES_TRANSFER,
        payload: resp,
      });
    }).catch(error => {
      dispatch(setSnackbar(error));
    });
    dispatch(stopRequestComp('invoicesTransferLoading'));
  };
};

export const getInvoiceTransferPdf = (file, token) => {
  return async dispatch => {
    const url = `${mainUrl}/transfers/report/file?path=${file}&qid=${qid}`;
    dispatch(startRequestComp('downloadInvoicesTransferLoading'));
    const options = {
      method: 'GET',
      url,
      headers: { Authorization: token },
      responseType: 'blob',
    };
    try {
      await axios.request(options).then(resp => {
        saveAs(resp.data, `${file}`);
        dispatch(stopRequestComp('downloadInvoicesTransferLoading'));
      });
    } catch (_error) {
      dispatch(setSnackbar(_error));
      dispatch(stopRequestComp('downloadInvoicesTransferLoading'));
    }
  };
};

export const selectInvoiceId = (id) => {
  return {
    type: SELECT_INVOICE_ID,
    payload: id,
  };
};

export const setFormCancelInvoice = (input) => {
  return {
    type: SET_FORM_CANCEL_INVOICE,
    payload: input,
  };
};

export const cancelInvoice = (id = '', form) => {
  const url = `${mainUrl}/${id}/cancel?qid=${qid}`;
  return async (dispatch) => {
    dispatch(startRequestComp('cancelInvoiceTransferLoading'));
    await api_post(url, form).then(resp => {
      dispatch({ type: CANCEL_INVOICE_TRANSFER, payload: { url: resp.url, id } });
      dispatch(setSnackbar(resp?.message, 'success'));
      dispatch(stopRequestComp('cancelInvoiceTransferLoading'));
      dispatch(setFormCancelInvoice(false));
      saveAs(resp.url, `Acuse-${id}.xml`);
    }).catch(_error => {
      dispatch(setSnackbar('Error al descargar el archivo'));
      dispatch(stopRequestComp('cancelInvoiceTransferLoading'));
    });
  };
};

export const downloadInvoiceFile = (id, active = false) => {
  return async dispatch => {
    dispatch(startRequestComp('downloadInvoiceLoading'));
    try {
      await api_get(`${mainUrl}/${id}/downloads?qid=${qid}&${!active ? 'xml=true' : 'pdf=true'}`).then(response => {
        const fileType = `${id}.${!active ? 'xml' : 'pdf'}`;
        const resp = !active ? response.xml : response.pdf;
        saveAs(resp, fileType);
      });
    } catch (error) {
      dispatch(setSnackbar(error));
    }
    dispatch(stopRequestComp('downloadInvoiceLoading'));
  };
};

export const forwardEmail = (id, form, close = null) => {
  const url = `${mainUrl}/${id}/resend?qid=${qid}`;
  return async dispatch => {
    dispatch(startRequestComp('forwardEmailLoading'));
    await api_post(url, form).then(_resp => {
      dispatch(setSnackbar('Mensaje Enviado con éxito', 'success'));
      dispatch(stopRequestComp('forwardEmailLoading'));
      close && close();
    }).catch(_error => {
      dispatch(stopRequestComp('forwardEmailLoading'));
      dispatch(setSnackbar('Error al enviar el mensaje'));
    });
  };
};

export const clearInvoices = () => {
  return {
    type: CLEAR_INVOICES,
  };
};

export const downloadPdfByToken = (pdfToken, fileName = 'invoice.pdf') => {
  return async dispatch => {
    dispatch(startRequestComp('downloadPdfLoading'));
    try {
      const options = {
        method: 'GET',
        url: `${process.env.REACT_APP_URL_PAY}/invoices/download-token?token=${encodeURIComponent(pdfToken)}&qid=${qid}`,
        headers: {},
        responseType: 'blob',
      };
      await axios.request(options).then(response => {
        saveAs(response.data, fileName);
        dispatch(setSnackbar(`Descargando archivo ${fileName}`, 'info'));
      });
    } catch (_error) {
      dispatch(setSnackbar('Error al descargar el PDF'));
    }
    dispatch(stopRequestComp('downloadPdfLoading'));
  };
};
